module.exports = __webpack_public_path__ + "static/media/vf_mvest_core.099d66a5.svg";